import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { UserCheck } from "lucide-react";

export const DuplicateClientDialog = ({ info, onConfirm, onCancel }) => (
  <Dialog open={!!info} onOpenChange={(o) => !o && onCancel()}>
    <DialogContent data-testid="duplicate-client-dialog" className="sm:max-w-md">
      <DialogHeader>
        <DialogTitle className="font-heading text-sky-900 text-xl flex items-center gap-2">
          <UserCheck className="w-5 h-5 text-amber-500" />
          Cliente existente
        </DialogTitle>
        <DialogDescription data-testid="duplicate-client-message">
          {info?.accessible
            ? "Este cliente ya existe, ¿querés agregarle un viaje nuevo?"
            : "Este cliente ya existe y está asignado a otro vendedor. Pedile al administrador que te lo asigne."}
        </DialogDescription>
      </DialogHeader>
      <div className="rounded-lg bg-sky-50 border border-sky-100 px-4 py-3 text-sm text-sky-900 font-medium" data-testid="duplicate-client-name">
        {info?.client_name}
      </div>
      <div className="flex gap-2 justify-end">
        <Button variant="outline" onClick={onCancel} className="border-sky-200 text-sky-700" data-testid="duplicate-cancel-button">
          Cancelar
        </Button>
        {info?.accessible && (
          <Button onClick={onConfirm} className="btn-sky text-white" data-testid="duplicate-add-trip-button">
            Sí, agregar viaje
          </Button>
        )}
      </div>
    </DialogContent>
  </Dialog>
);
